import {Component, OnInit, OnDestroy, ViewEncapsulation} from '@angular/core';
import {AppConfig} from "./app.config";
import {Auth} from "./app.auth";
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";

@Component({
  encapsulation: ViewEncapsulation.None,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    isLoading = false;
    auth: Auth;

    constructor(auth: Auth) {
        this.auth = auth;
    }

    ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts